import { userService } from '../_services'
import axios from 'axios'
import { authHeader } from '../_helpers'

const state = {
  all: {},
  user: {}
}

const actions = {
  getAll ({ commit, dispatch }) {
    dispatch('alert/clear', null, { root: true })
    commit('getAllRequest')

    userService.getAll()
      .then(
        users => commit('getAllSuccess', users),
        error => commit('getAllFailure', error)
      )
  },
  getUserInfo ({ commit, dispatch }, id) {
    dispatch('alert/clear', null, { root: true })
    axios.get(process.env.VUE_APP_URL + `users/${id}`, { headers: authHeader() })
      .then(response => {
        localStorage.setItem('StartDate', response.data.startWorkTime)
        localStorage.setItem('EndDate', response.data.endWorkTime)
        commit('getUserInfoSuccess', response.data)
      })
      .catch(error => {
        var errorCode = error.response.status
        switch (errorCode) {
          // case 400:
          //   dispatch('alert/error', 'Произошла ошибка:' + ' Ошибка загрузки данных. Проверьте токен доступа системы топливных карт', { root: true })
          //   break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
        dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
      })
  },
  updateUserInfo ({ commit, dispatch }, user) {
    dispatch('alert/clear', null, { root: true })
    const requestBody = {
      fullName: user.fullName,
      login: user.login,
      email: user.email,
      petrolToken: user.petrolToken,
      shellToken: user.shellToken,
      rnToken: user.rnToken,
      startWorkTime: user.startWorkTime,
      endWorkTime: user.endWorkTime
    }
    axios.put(process.env.VUE_APP_URL + `users/${user.id}`, requestBody, { headers: authHeader() })
      .then(response => {
        dispatch('alert/success', 'Информация о профиле обновлена', { root: true })
        dispatch('getUserInfo', user.id)
      })
      .catch(error => {
        var errorCode = error.response.status
        switch (errorCode) {
          // case 400:
          //   dispatch('alert/error', 'Произошла ошибка:' + ' Ошибка загрузки данных. Проверьте токен доступа системы топливных карт', { root: true })
          //   break
          case 401:
            dispatch('account/logout', {}, { root: true })
            return
          default:
            dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
            break
        }
        dispatch('alert/error', 'Произошла ошибка:' + error, { root: true })
      })
  },
  delete ({ commit, dispatch }, id) {
    dispatch('alert/clear', null, { root: true })
    commit('deleteRequest', id)

    userService.delete(id)
      .then(
        user => commit('deleteSuccess', id),
        error => commit('deleteFailure', { id, error: error.toString() })
      )
  }
}

const mutations = {
  getUserInfoSuccess (state, user) {
    state.user = user
    localStorage.setItem('petrolToken', user.petrolToken)
  },
  getAllRequest (state) {
    state.all = { loading: true }
  },
  getAllSuccess (state, users) {
    state.all = { items: users }
  },
  getAllFailure (state, error) {
    state.all = { error }
  },
  deleteRequest (state, id) {
    // add 'deleting:true' property to user being deleted
    state.all.items = state.all.items.map(user =>
      user.id === id
        ? { ...user, deleting: true }
        : user
    )
  },
  deleteSuccess (state, id) {
    // remove deleted user from state
    state.all.items = state.all.items.filter(user => user.id !== id)
  },
  deleteFailure (state, { id, error }) {
    // remove 'deleting:true' property and add 'deleteError:[error]' property to user
    state.all.items = state.items.map(user => {
      if (user.id === id) {
        // make copy of user without 'deleting:true' property
        const { deleting, ...userCopy } = user
        // return copy of user with 'deleteError:[error]' property
        return { ...userCopy, deleteError: error }
      }

      return user
    })
  }
}

export const users = {
  namespaced: true,
  state,
  actions,
  mutations
}
